import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { MyMatchesService } from '@statistics/export';

@Injectable({
    providedIn: 'root',
})
export class ParticipantResolverService {
    public constructor(public matches: MyMatchesService) {}

    public resolve(route: ActivatedRouteSnapshot): Observable<number[] | null> {
        const id = route.paramMap.get('matchId') || null;
        const source = route.queryParamMap.get('source') || null;
        let obs: Observable<any>;

        const idValFinal = id;

        if (idValFinal === null) {
            obs = of([]);
        } else if (source === null) {
            obs = this.matches.brToId(idValFinal.toString());
        } else {
            obs = this.matches.sourceIdToId(idValFinal.toString(), source);
        }
        return obs.pipe(
            mergeMap(
                (ids: number[]): Observable<number[] | null> => {
                    if (ids.length > 0) {
                        return of(ids);
                    }
                    return of(null);
                },
            ),
        );
    }
}
